/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileUrl } from '../../models/file-url';

export interface ApiFileUrlFileIdGet$Params {
  file_id: number;
}

export function apiFileUrlFileIdGet(http: HttpClient, rootUrl: string, params: ApiFileUrlFileIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUrl>> {
  const rb = new RequestBuilder(rootUrl, apiFileUrlFileIdGet.PATH, 'get');
  if (params) {
    rb.path('file_id', params.file_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileUrl>;
    })
  );
}

apiFileUrlFileIdGet.PATH = '/api/file/url/{file_id}';
